﻿/**
 * @fileOverview re_listingdiscovery_utility_control.js
 *
 * @author Chris Girard
 * 
 * @events
 */

define(['jquery', 'pubsub', 'generalUtilities', 'MarkerClusterer', 'lazysizes'],

	function listingDiscoveryUtilities($, pubsub, generalUtilities, MarkerClusterer) {

		// #region set up
		'use strict';

		var module, selectors, elements;

		module = {};
		module.private = {};
		module.properties = {};
		selectors = {
			'btnGridView': '.js-grid-view',
			'btnMapView': '.js-map-view',
			'listingsContainer': '.listings-list-container',
			'btnGetGeoLocation': '.js-geolocation-btn'
		};
		elements = {};

		// #endregion

		// #region utilities

		/**
		* Parses the listing obj and formats the suite number
		* @param {object} listing object
		* @return HTML
		*/
		module.private.checkingSuiteNumber = function checkingSuiteNumber(m) {
			var html, marker;

			html = '';
			marker = {};

			if (typeof m.re_data === 'object') {
				marker = m;
			} else {
				marker.re_data = m;
			}

			if (marker.re_data.SuiteNumber2) {
				if (marker.re_data.Country === 'USA') {
					html += marker.re_data.Address + ' #' + marker.re_data.SuiteNumber2;
				} else {
					html += marker.re_data.SuiteNumber2 + ' - ' + marker.re_data.Address;
				}
			} else {
				html += marker.re_data.Address;
			}

			return html
		}

		/**
		* Parses the listing obj and formats bath and beds
		* @param {object} listing object
		* @return HTML
		*/
		module.private.checkingBedBathroom = function checkingBedBathroom(m) {
			var html, marker;

			html = '';
			marker = {};

			if (typeof m.re_data === 'object') {
				marker = m;
			} else {
				marker.re_data = m;
			}

			if (marker.re_data.Bedrooms !== 0) {
				html += marker.re_data.Bedrooms + ' ' + RESAAS.Localization.Global.BED_TEXT;
			}

			if (marker.re_data.Bathrooms !== 0) {
				if (marker.re_data.Bedrooms !== 0) {
					html += ' | ';
				}
				html += marker.re_data.Bathrooms + ' ' + RESAAS.Localization.Global.BATH_TEXT;
			}

			return html;
		}

		/**
		* Parses the listing obj and formats the suite number
		* @param number
		* @return number
		*/
		module.getGridSizeByZoom = function getGridSizeByZoom(zoom) {
			if (zoom <= 12) {
				return 30;
			} 
			return 10;
		}

		/**
		* Parses the query string Obj and updates the url
		* @param {string} set {object} query object
		* @return url path
		*/
		module.private.handleQueryString = function handleQueryString(type, queryObject) {
			var text = "";
			for (var key in queryObject) {
				text += "&" + key + "=" + queryObject[key];
			}

			if (history.replaceState) {
				var newurl = window.location.pathname + '?' + text;
				window.history.replaceState({ path: newurl }, '', newurl);
			}

		}

		/**
		* Switch view to grid view
		*/
		module.private.switchToGridView = function switchToGridView() {
			$('.listings-list-container').addClass('grid-view');
			$('.listing-in-list').addClass('grid-view');
			$(selectors.btnGridView).addClass('active-view');
			$(selectors.btnMapView).removeClass('active-view');
			$('.refresh-search-wrapper').css('display', 'none');
			$('.toggle-search-wrapper').css('display', 'none');
			pubsub.publish('mixpanel.Intent', { type: 'grid view', from: window.pageType });
		}

		/**
		* Switch view to map view
		*/
		module.private.switchToMapView = function switchToMapView() {
			$('.listings-list-container').removeClass('grid-view');
			$('.listing-in-list').removeClass('grid-view');
			$('#map-canvas').removeClass('grid-view');
			$(selectors.btnGridView).removeClass('active-view');
			$(selectors.btnMapView).addClass('active-view');
			$('.toggle-search-wrapper').css('display', 'inline-block');
			pubsub.publish('mixpanel.Intent', { type: 'map view', from: window.pageType });
			// google.maps.event.trigger(map, "resize");
		}

		module.private.setHeights = function setHeights() {
			var windowHeight, formHeight, mapHeight, listingDiscoveryHeader, listingDiscoveryHeaderRect, floatingElementTop;

			windowHeight = $(window).height();

			listingDiscoveryHeader = document.querySelector('.listing-discovery-header');
			listingDiscoveryHeaderRect = (listingDiscoveryHeader) ? listingDiscoveryHeader.getBoundingClientRect() : { top: 0, height: 0 };

			formHeight = listingDiscoveryHeaderRect.top + listingDiscoveryHeaderRect.height;

			mapHeight = windowHeight - formHeight - 1;
			floatingElementTop = formHeight + 20;

			$('.listings-list-container').height(mapHeight);
			$('#map-canvas').height(mapHeight);

			// update position for nav-2017
			if (!generalUtilities.getNavigationState().isCompact) { //full nav view
				$('#map-canvas')
					.add('.listings-list-container')
					.add('.listing-sort-options')
					.css({ 'top': formHeight + 'px' });

				$('.re-page-wrapper').css({ 'margin-top': floatingElementTop + 'px' });

				//compact view
			} else {
				$('#map-canvas')
					.add('.listings-list-container')
					.add('.listing-sort-options')
					.add('.re-nav-container')
					.add('.re-nav-secondary-experiences')
					.css({ 'top': '' });
			}

			$('.re-listing-search').css({ 'top': floatingElementTop + 'px' });
		};

		/**
		* Sets the mapOptions center point and zoon
		* @param {defaultLocation} set {object} mapOptions
		*/
		module.getLocationFromUser = function getLocationFromUser(defaultLocation) {
			var userLatitude, userLongitude, mapOptions;

			userLatitude = generalUtilities.prop(RESAAS, 'User2.Latitude');
			userLongitude = generalUtilities.prop(RESAAS, 'User2.Longitude');

			if (defaultLocation) {
				mapOptions = {
					zoom: defaultLocation.zoom,
					center: { lat: defaultLocation.center.lat, lng: defaultLocation.center.lng }
				};

				pubsub.publish('data.RenderMap', mapOptions);
			} else if (userLatitude && userLongitude) {
				mapOptions = {
					zoom: 12,
					center: { lat: RESAAS.User2.Latitude, lng: RESAAS.User2.Longitude }
				};

				pubsub.publish('data.RenderMap', mapOptions);
			} else {
				mapOptions = {
					zoom: 3,
					center: { lat: 40.825763, lng: -96.685198 }
				};

				pubsub.publish('data.RenderMap', mapOptions);
			}
		};

		/**
		* Sets the mapOptions center point based on query string
		* @param {defaultLocation} set {object} mapOptions
		*/
		module.setMapCenterPoint = function setMapCenterPoint(defaultLocation) {
			var queries, mapOptions, groupNameLabel, groupNameQuery;

			// if a querystring exists
			if (window.location.search) {
				queries = generalUtilities.queryStringToObjectPlus(document.location.search); // href

				groupNameQuery = (queries.gpn) ? queries.gpn : (queries.gn) ? queries.gn : null;

				if (queries.address) {
					$('#autocomplete').val(decodeURIComponent(queries.address));
				}

				if (queries.rtf) {
					$('.recent-time-filter').val(queries.rtf);
				}

				if (queries.mnp) {
					$('.min-price-filter').val(queries.mnp);
				}

				if (queries.mxp) {
					$('.max-price-filter').val(queries.mxp);
				}

				if (queries.mnb) {
					if (queries.mnb.match(/\d/)) {
						$('.min-beds-filter').val(queries.mnb);
					} else {
						$('.min-beds-filter').val(RESAAS.Localization.Global.BEDROOMS_TEXT);
					}
				}

				if (queries.mnba) {
					if (queries.mnba.match(/\d/)) {
						$('.min-baths-filter').val(queries.mnba);
					} else {
						$('.min-baths-filter').val(RESAAS.Localization.Global.BATHROOMS_TEXT);
					}
				}

				if (queries.pr) {
					$('.property-type-filter').val(queries.pr);
				}

				if (queries.ls==="3" && (!RESAAS.User2.IsProfessional || RESAAS.User2.IsPendingProfessional)) {
					$('.listing-status-filter').val(0);
				}
				else if (queries.ls) {
					$('.listing-status-filter').val(queries.ls);
				}

				if (groupNameQuery != null) {
					groupNameQuery = decodeURI(groupNameQuery);
					$('.group-name-filter').val(groupNameQuery);
					groupNameLabel = generalUtilities.stringFormat(RESAAS.Localization.Global.GROUP_NAME, groupNameQuery);
					$('.group-name-label').html(groupNameLabel);
					$('.group-name-filter').show();
				}

				if (queries.gn) {
					$('.group-name-filter').data('name', queries.gn);
				}

				if (queries.st) {
					if (queries.st === "0") {
						$('.search-type-filter').prop('checked', true);
					} else {
						$('.search-type-filter').prop('checked', false);
					}
				}
				if (queries.bo) {
					if (queries.bo === "0") {
						$('.broker-filter').prop('checked', true);
					} else {
						$('.broker-filter').prop('checked', false);
					}
				}

				if (!isNaN(queries.la) && !isNaN(queries.lo) && !isNaN(queries.z)) {
					mapOptions = {
						zoom: parseInt(queries.z, 10),
						center: { lat: Number(queries.la), lng: Number(queries.lo) }
					};

					pubsub.publish('data.RenderMap', mapOptions);
				} else {
					module.getLocationFromUser(defaultLocation);
				}

			} else {
				module.getLocationFromUser(defaultLocation);
			}
		};

		module.generateListingCard = function generateListingCard(d, mlsData) {
			var html, MLSGroupString;

			MLSGroupString = mlsData.read(d.MLSGroupType).string;
			html = '<a href="' +
				d.SeoUrl +
				'" target="_blank" class="listing-in-list" data-id="' +
				d.UniqueKey +
				'"><span><p class="listing-price text-bold">' +
				d.FormattedPrice + ' ' + d.CurrencyCode + '</p></span>';

			var listingImageUrlList = module.private.generateListingImageUrl(d.Images[1].Url);

			html += '<div class="listing-image-wrapper">';

			html += '<img class="listing-in-list-image lazyload" data-src="' + listingImageUrlList.imageUrl + '"' +
				'sizes="(min-width: 45em) 320px, 634px"' +
				'data-srcset="' + listingImageUrlList.imageUrl + ' 320w, ' + listingImageUrlList.imageUrlResponsive + ' 634w, ' + listingImageUrlList.imageUrlResponsiveRetina + ' 1268w"/>';

			html += '<div class="listing-status-container">';

			if (d.IsSold) {
				if (d.ListingTransactionType === 1) {
					html += '<span class="re-post-label listing-sold"><span>' + RESAAS.Localization.Listings.LEASED_TEXT + '</span></span>';
				} else {
					html += '<span class="re-post-label listing-sold"><span>' + RESAAS.Localization.Listings.SOLD_TEXT + '</span></span>';
				}
			} else if (d.MarketStatus === 1) {
				html += '<span class="re-post-label mls-premarket-featured"><span class="re-icon re-icon-xs re-icon-lock">' + RESAAS.Localization.Listings['PREMARKET_LABEL_' + MLSGroupString.toUpperCase()] + '</span></span>';
			}

			html += '</div>'; // listing-status-container
			html += '</div>'; // listing-image-wrapper

			html += '<div class="listing-in-list-details"><p class="text-bold">';

			if (d.SuiteNumber2) {
				if (d.Country === 'USA') {
					html += d.Address + ' #' + d.SuiteNumber2;
				} else {
					html += d.SuiteNumber2 + ' - ' + d.Address;
				}

			} else {
				html += d.Address;
			}

			html += ", " + d.City + '</p><p class="listing-list-bed-and-bath">';

			if (d.Bedrooms !== 0) {
				html += d.Bedrooms + ' ' + RESAAS.Localization.Global.BED_TEXT;
			}

			if (d.Bathrooms !== 0) {
				if (d.Bedrooms !== 0) {
					html += ' | ';
				}
				html += d.Bathrooms + ' ' + RESAAS.Localization.Global.BATH_TEXT;
			}

			html += '</p></div></a>';

			return html;
		};

		module.getMarker = function getMarker(id, markers) {
			var selectedMarker;
			$.each(markers, function eachFunc(i, marker) {
				if (marker.key === id) {
					selectedMarker = marker;
				}
			});
			return selectedMarker;
		};

		module.clearOpenedInfoWindows = function clearOpenedInfoWindows(infowindows) {
			$.each(infowindows, function eachFunc(i, infowindow) {
				infowindow.close();
			})
		};

		module.openInfoWindow = function openInfoWindow(id, infowindows, markers, map) {
			$.each(infowindows, function eachFunc(i, infowindow) {
				var mkr;

				if ($(infowindow.getContent()).data('id') === id) {
					mkr = module.getMarker(id, markers);
					infowindow.open(map, mkr);
					if (!map.getBounds().contains(mkr.getPosition())) {
						map.setCenter(mkr.getPosition());
					} else {
						module.moveMapIfElementOverlayedByNav(map, mkr)
					}
				}
			})
		};

		module.createIWindowMarkup = function createIWindowMarkup(d, mlsData) {
			var html = '<div class="individual-listing-container"> <a target="_blank" href="' +
				d.SeoUrl +
				'" class="listing-pop-up" data-id="' +
				d.UniqueKey + '">' +
				'<p class="listing-price cluster-price text-bold">' +
				d.FormattedPrice + ' ' + d.CurrencyCode +
				'</p>';

			var listingImageUrlList = module.private.generateListingImageUrl(d.Images[1].Url);

			html += '<div class="listing-image-wrapper">';

			html += '<img class="individual-listing-image" src="' + listingImageUrlList.imageUrl + '"' +
				'sizes="(min-width: 45em) 320px, 634px"' +
				'srcset="' + listingImageUrlList.imageUrl + ' 320w, ' + listingImageUrlList.imageUrlResponsive + ' 634w, ' + listingImageUrlList.imageUrlResponsiveRetina + ' 1268w"/>';

			html += '<div class="listing-status-container">';

			if (d.IsSold) {
				if (d.ListingTransactionType === 1) {
					html += '<span class="re-post-label listing-sold"><span>' + RESAAS.Localization.Listings.LEASED_TEXT + '</span></span>';
				} else {
					html += '<span class="re-post-label listing-sold"><span>' + RESAAS.Localization.Listings.SOLD_TEXT + '</span></span>';
				}
			} else if (d.MarketStatus === 1) {
				html += '<span class="re-post-label mls-premarket-featured"><span class="re-icon re-icon-xs re-icon-lock">' + RESAAS.Localization.Listings['PREMARKET_LABEL_' + mlsData.read(d.MLSGroupType).string.toUpperCase()] + '</span></span>';
			}

			html += '</div>'; // listing-status-container
			html += '</div>'; // listing-image-wrapper

			html += '</a>'

			html += '<a target="_blank" class="listing-popup-details" href="' +
				d.SeoUrl +
				'"><p class="text-bold">' +
				module.private.checkingSuiteNumber(d) +
				", " + d.City +
				'</p><p class="popup-bed-and-bath">' +
				module.private.checkingBedBathroom(d) +
				'</p>';

			html += '</a></div>';

			return html;
		};

		module.getSearchListingValues = function getSearchListingValues(map, serviceSettings) {
			var bedFilterValue, bathFilterValue, bedQueryValue, bathQueryValue, queryObject, criteriaObject, bedroomsPlus, bathroomsPlus, searchType, groupName;

			bedFilterValue = $('.min-beds-filter option:selected').attr('data-value');
			bathFilterValue = $('.min-baths-filter option:selected').attr('data-value');
			bedQueryValue = $('.min-beds-filter option:selected').val();
			bathQueryValue = $('.min-baths-filter option:selected').val();

			if ($('.min-beds-filter').val().toString().indexOf('+') === 1) {
				bedroomsPlus = true;
			}

			if ($('.min-baths-filter').val().toString().indexOf('+') === 1) {
				bathroomsPlus = true;
			}

			if ($('.group-name-filter').prop('checked') && $('.group-name-label').text() !== "") {
				groupName = $('.group-name-filter').data('name');
			} else {
				groupName = "";
			}

			queryObject = {
				"rtf": $('.recent-time-filter').val(),
				"mnp": $('.min-price-filter').val(),
				"mxp": $('.max-price-filter').val(),
				"pr": $('.property-type-filter').val(),
				"mnb": bedQueryValue,
				"mnba": bathQueryValue,
				"ls": $('.listing-status-filter').val(),
				"z": map.getZoom(),
				"la": map.getCenter().lat(),
				"lo": map.getCenter().lng(),
				"gn": groupName
			};

			criteriaObject = {
				"MLSGroupName": serviceSettings.group,
				"SortBy": $('.sort-options-dropdown').val(),
				"SortDesc": $('.sort-options-dropdown option:selected').attr('data-sort'),
				"MaxListingAgeInDays": $('.recent-time-filter').val(),
				"PriceFrom": $('.min-price-filter').val(),
				"PriceTo": $('.max-price-filter').val(),
				"PropertyTypeId": $('.property-type-filter').val(),
				"ShowForSaleSold": $('.listing-status-filter').val(),
				"Bedrooms": bedFilterValue,
				"BedroomsPlus": bedroomsPlus,
				"Bathrooms": bathFilterValue,
				"BathroomsPlus": bathroomsPlus,
				"RecordCount": "200",
				"Longitude1": map.getBounds().getNorthEast().lng().toString(), "Latitude1": map.getBounds().getSouthWest().lat().toString(),
				"Longitude2": map.getBounds().getNorthEast().lng().toString(), "Latitude2": map.getBounds().getNorthEast().lat().toString(),
				"Longitude3": map.getBounds().getSouthWest().lng().toString(), "Latitude3": map.getBounds().getNorthEast().lat().toString(),
				"Longitude4": map.getBounds().getSouthWest().lng().toString(), "Latitude4": map.getBounds().getSouthWest().lat().toString(),
				"OwnerGroupUniqueName": groupName
			};

			if ($('.search-type-filter')) {
				var searchType = $('.search-type-filter').prop('checked') ? "0" : "1";
				queryObject.st = searchType;
				criteriaObject.SearchType = searchType;
			}
			if (RESAAS.User2.BrokerOwner && (RESAAS.User2.FirmId !== null || RESAAS.User2.FirmId !== "")) {
				var searchType = $('.broker-filter').prop('checked') ? "0" : "1";
				queryObject.bo = searchType;
				if (searchType === "0") {
					criteriaObject.FirmId = RESAAS.User2.FirmId;
				}
			}

			return { query: queryObject, criteria: criteriaObject }
		};

		module.private.getGeoLocationSuccess = function getGeoLocationSuccess(position) {
			var mapOptions = {
				zoom: 12,
				center: { lat: position.coords.latitude, lng: position.coords.longitude }
			};

			pubsub.publish('data.RenderMap', mapOptions);
		};

		module.private.getGeoLocationError = function getGeoLocationError(error) {
			var errorMsg;

			switch (error.code) {
				case error.PERMISSION_DENIED:
					errorMsg = RESAAS.Localization.Listings.LISTING_SEARCH_GEO_PERMISSION_DENIED;
					break;
				case error.POSITION_UNAVAILABLE:
					errorMsg = RESAAS.Localization.Listings.LISTING_SEARCH_GEO_POSITION_UNAVAILABLE;
					break;
				case error.TIMEOUT:
					errorMsg = RESAAS.Localization.Listings.LISTING_SEARCH_GEO_TIMEOUT;
					break
				default:
					errorMsg = RESAAS.Localization.Listings.LISTING_SEARCH_GEO_TIMEOUT;
					break;
			}

			pubsub.publish('uiAction.MessageAdd', {
				message: errorMsg,
				type: 'error'
			});
		};

		module.private.getGeoLocation = function getGeoLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(module.private.getGeoLocationSuccess, module.private.getGeoLocationError, {timeout: 15000});
			} 
		};

		module.private.injectGeoLocationButton = function injectGeoLocationButton(geolocation) {
			if (geolocation) {
				$(selectors.listingsContainer).append([
					'<button type="button" class="js-geolocation-btn re-geolocation-btn re-icon-custom re-icon-gps-location-black" title="',
					RESAAS.Localization.Listings.LISTING_SEARCH_USE_MY_LOCATION,
					'"></button>'
				].join(''));
				$(selectors.btnGetGeoLocation).on('click', module.private.getGeoLocation);
			}
		};

		module.private.hasDuplicateLocation = function hasDuplicateLocation(markerToCheck, index, markers) {
			var markersLength = markers.length;
			for (var i = 0; i < markersLength; i++) {
				if (index !== i && markerToCheck.re_data.Latitude === markers[i].re_data.Latitude && markerToCheck.re_data.Longitude === markers[i].re_data.Longitude) {
					return true
				}
			}
			return false
		};

		module.getMarkersWithDuplicateLocation = function getMarkersWithDuplicateLocation(markers) {
			return markers.filter(module.private.hasDuplicateLocation);
		};

		module.private.filterListingsForCluster = function filterListingsForCluster(zoom, markers) {
			// if map is zoomed in, only cluster pins that have the exact same locations
			if (zoom > 9) {
				return module.getMarkersWithDuplicateLocation(markers);
			} else {
				// if map is zoomed out, do the clustering normally
				return markers;
			}
		};

		module.createMarkerCluster = function createMarkerCluster(zoom, markers, map) {
			var markersToBeClustered, markerCluster, gridSize;
			gridSize = module.getGridSizeByZoom(zoom);
			markersToBeClustered = module.private.filterListingsForCluster(zoom, markers)
			markerCluster = new MarkerClusterer(map, markersToBeClustered, {
				'gridSize': gridSize,
				'maxZoom': null,
				'zoomOnClick': true,
				'averageCenter': true,
				'styles': [{
					textColor: 'white',
					height: 53,
					width: 53,
					url: '/assets/home/images/ui/map/icon1.png'
				},
				{
					textColor: 'white',
					height: 53,
					width: 53,
					url: '/assets/home/images/ui/map/icon2.png'
				},
				{
					textColor: 'white',
					height: 53,
					width: 53,
					url: '/assets/home/images/ui/map/icon3.png'
				}]
			});

			return markerCluster;
		};

		module.private.generateListingImageUrl = function generateListingImageUrl(url) {
			var listingImageUrlList = {};

			listingImageUrlList.imageUrl = generalUtilities.addParamsToUrlQueryString(url, {
				width: 320,
				height: 180,
				mode: 'crop',
				quality: 80
			});

			listingImageUrlList.imageUrlResponsive = generalUtilities.addParamsToUrlQueryString(url, {
				width: 634,
				height: 357,
				mode: 'crop',
				quality: 80
			});

			listingImageUrlList.imageUrlResponsiveRetina = generalUtilities.addParamsToUrlQueryString(url, {
				width: 1268,
				height: 714,
				mode: 'crop',
				quality: 80
			});

			return listingImageUrlList;
		};

		module.moveMapIfElementOverlayedByNav = function moveMapIfElementOverlayedByNav(map, marker) {
			var nav, navPosition, point, navEndCoords, overlay, markerPosition;

			nav = document.querySelector('.re-page-navigation #re-nav');

			if (nav) {
				navPosition = nav.getBoundingClientRect();
				navEndCoords = navPosition.x + navPosition.width + 500;
				markerPosition = marker.getPosition();

				// calculate target position in pixels
				overlay = new google.maps.OverlayView();
				overlay.draw = function () { };
				overlay.setMap(map);
				point = overlay.getProjection().fromLatLngToContainerPixel(markerPosition);

				if (point.x <= navEndCoords) {
					map.panTo(markerPosition);
				}
			}
		}

		/*
		 * Show/hide logic of "Redo search" button and "Search as I move the map" checkbox
		 * is localized here.
		 */
		module.handleRefreshBtn = function handleRefreshBtn(dragged) {
			var $checkboxWrapper = $('.toggle-search-wrapper');
			var $refreshWrapper = $('.refresh-search-wrapper');
			var $toggleCheckbox = $('#toggle-refresh-checkbox');

			if ($toggleCheckbox.prop('checked')) {
				$checkboxWrapper.show();
				$refreshWrapper.hide();
			} else if (dragged) {
				$checkboxWrapper.hide();
				$refreshWrapper.show();
			} else {
				$checkboxWrapper.show();
				$refreshWrapper.hide();
			}
		};

		module.hideToggleAndRefreshSearch = function handleToggleAndRefreshSearchVisibility() {
			var $checkboxWrapper = $('.toggle-search-wrapper');
			var $refreshWrapper = $('.refresh-search-wrapper');
			var $listContainer = $('.listings-list-container');

			if (generalUtilities.getNavigationState().isCompact || $listContainer.hasClass('grid-view')) {
				$checkboxWrapper.hide();
				$refreshWrapper.hide();
			} else {
				module.handleRefreshBtn(true);
			}
		}

		// #endregion
		
		// #region external event bindings

		/**
		* Initiates the module, creates a guid and binds dom events.
		*/
		module.private.init = function (e, data) {
			//module config
			module.properties.guid = (data && data.guid) ? data.guid : generalUtilities.uuid();
			elements.body = $('body');

			module.private.injectGeoLocationButton(navigator.geolocation);

			//dom event binding
			$(selectors.btnMapView).on('click', module.private.switchToMapView);
			$(selectors.btnGridView).on('click', module.private.switchToGridView);
		};
		// #endregion

		module.private.init();

		// expose API
		return module;
	}
);
